import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/booking/importer/bookingImporterActions';

export default importerReducers(actions);
